import React, {useState} from 'react';
import {Popover, PopoverBody} from "reactstrap";
import DropdownItem from "../../clipstore/broadcaster/library/dropdown-item/DropdownItem";
import assets from "../../../util/assets";
import "./index.css";

ChatWindowAttachmentDropdown.propTypes = {};

function ChatWindowAttachmentDropdown(props) {

    const [popoverOpen, setPopoverOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const toggle = () => setPopoverOpen(!popoverOpen);

    const dropDownItem = [{
        slug: 'published-content',
        title: "Published content",
        icon: assets.messaging.attachment.published,
        action: () => {
            console.log("Published content")
            props.setAttachmentModal(true, 'published-content', "selection")
        }
    }, {
        slug: 'my-library',
        title: "My library",
        icon: assets.messaging.attachment.my_library,
        action: () => {
            console.log("My Library")
            props.setAttachmentModal(true, 'my-library', "selection")
        }
    }, {
        slug: 'pc',
        title: "Upload from my PC",
        icon: assets.messaging.attachment.pc,
        action: () => {
            console.log("Upload from my PC")
            props.uploadFromPC()
        }
    }];


    return (
        <div>
            <img
                className="cursor-pointer padding-16"
                src={popoverOpen ? assets.messaging.bottom.attachment_active : assets.messaging.bottom.attachment_inactive}
                id={`chat-window-attachment`}/>

            <Popover placement="bottom" isOpen={popoverOpen} target={`chat-window-attachment`} toggle={toggle}
                     className="chat-window-detail-header-popover">
                <PopoverBody className="my-library-actions-pop-over-body">
                    <div>
                        {
                            dropDownItem.map((item, index) => {
                                return (
                                    <DropdownItem
                                        isFetching={props.isFetching && selectedItem === item}
                                        key={`chat-window-dropdown-item-${index}`}
                                        onClick={() => {
                                            toggle();
                                            setSelectedItem(item)
                                            item.action();
                                        }}
                                        icon={item.icon}
                                        text={item.title}
                                    />
                                )
                            })
                        }
                    </div>
                </PopoverBody>
            </Popover>
        </div>
    );
}

export default ChatWindowAttachmentDropdown;